const sentKey = (flow: string): string =>
  `anomalos.identity.codeSentAt.${flow}`;

export const markCodeSent = (flow: string, now = Date.now()): void => {
  sessionStorage.setItem(sentKey(flow), String(now));
};

export const readCodeSentAt = (flow: string): number | null => {
  const raw = sessionStorage.getItem(sentKey(flow));
  if (!raw) {
    return null;
  }
  const value = Number(raw);
  return Number.isFinite(value) ? value : null;
};

export const clearCodeSent = (flow: string): void => {
  sessionStorage.removeItem(sentKey(flow));
};
